import styled, { css } from 'styled-components';
import { Typography } from '../../global/theme';
import { mobile_xl } from '../../global/mediaQueryMixin';
import { AlignCenter, FlexBetween } from '../../global/commonStyle';

interface FileTypeProps {
  fontSize?: number;
}

const Card = styled.div`
  width: 100%;
  max-width: 230px;
  border: 0.5px solid var(--border-primary);
  background-color: var(--background-primary);
  box-shadow: var(--shadow-modal);
  border-radius: var(--border-radius-8);
  padding: var(--space-11);
  margin-bottom: var(--space-20);
  position: absolute;
  bottom: 0;
  left: 50%;
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
  z-index: var(--z-index-base);
  ${mobile_xl(css`
    bottom: 75px;
    transform: translateX(-50%);
  `)}
`;

const FileType = styled.div<FileTypeProps>`
  ${({ fontSize }) => fontSize && `font-size: ${fontSize}px;`}
`;

const Content = styled.div`
  ${FlexBetween}
  gap: var(--space-12);
`;

const FileIcon = styled.div`
  position: relative;
  display: flex;
  .upload-file-text {
    display: flex;
    justify-content: center;
    position: absolute;
    bottom: 28%;
    left: 25%;
    width: 50%;
    font-weight: 700;
    color: var(--text-primary);
  }
`;

const FileInfo = styled.div`
  width: 149px;
  display: flex;
  flex-direction: column;
`;

const FileName = styled.div`
  ${Typography.body_md_medium}
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: var(--text-primary);
`;

const FileSize = styled.div`
  color: var(--text-secondary);
  ${Typography.body_xs}
`;

const ProgressWrapper = styled.div`
  display: flex;
  padding: var(--space-0);
`;

const ProgressInfo = styled.p`
  margin: var(--space-0);
  ${Typography.body_sm}
  color: var(--text-primary);
`;

const FileDetail = styled.div`
  ${AlignCenter}
  gap: var(--space-6);
`;

export { ProgressInfo, Card, Content, FileIcon, FileInfo, FileName, FileSize, ProgressWrapper, FileDetail, FileType };
